import { Atom } from 'AppReact';
import styled from "styled-components";

const template = styled.input`
    width: 90px;
    height: 17px;
    font-size: 14px;
    color: #555555;
    border: none;
    outline: none;
`;


export default Atom({ type: 'keyInput', dataType: ['string', 'number'], template })